import { render, staticRenderFns } from "./ManageIndirectChannelPartnerPopUp.vue?vue&type=template&id=25206bdc&scoped=true&"
import script from "./ManageIndirectChannelPartnerPopUp.vue?vue&type=script&lang=js&"
export * from "./ManageIndirectChannelPartnerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ManageIndirectChannelPartnerPopUp.vue?vue&type=style&index=0&id=25206bdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25206bdc",
  null
  
)

export default component.exports